import React from 'react';
import Hint from 'components/Hint';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';

const CreatedByInfo = ({author}) => {
	const {t} = useTranslation();
	if (!author) {
		return null;
	}

	return (
		<Hint>
			{t('created_by')} {author.displayName}
		</Hint>
	);
};
export default CreatedByInfo;

CreatedByInfo.propTypes = {
	author: PropTypes.shape({
		displayName: PropTypes.string,
	}),
};
